import * as React from 'react';
import { NvHeading } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './ListOfLinksSection.module.esm.js';

var ListOfLinksSection = function (_a) {
    var _b = _a.fields, sectionHeading = _b.sectionHeading, items = _b.items, id = _a.id;
    return (React.createElement("div", { className: styles.root, "data-testid": "list-of-links-section", id: id },
        !!sectionHeading && (React.createElement(NvHeading, { className: styles.sectionHeading, element: "h4", level: 4 }, sectionHeading)),
        React.createElement("div", null, items.map(function (linkItem) { return (React.createElement(BaseNucleobaseComponent, { key: linkItem.sys.id, source: linkItem })); }))));
};

export { ListOfLinksSection as default };
//# sourceMappingURL=ListOfLinksSection.esm.js.map
